import React from "react";
import { SearchField } from "./_.styled";

const NarrowFilter = ({ value, placeholder, onChange, ...props }) => {
  return (
    <SearchField
      name="narrow-filter"
      data-testid="narrow-filter"
      onChange={onChange}
      value={value}
      placeholder={placeholder || "Find in list"}
      {...props}
    />
  );
};

export default NarrowFilter;
